import Box from '@mui/material/Box';
import FormControl, { type FormControlProps } from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import type { ReactNode } from 'react';

import { Text } from './text';

interface FieldProps {
  label?: string;
  error?: string;
  htmlFor?: string;
  sx?: FormControlProps['sx'];
  children: ReactNode;
}

export const fieldLabelId = (htmlFor: string): string => `${htmlFor}-label`;

export const Field = ({
  label,
  error,
  htmlFor,
  sx,
  children,
}: FieldProps): JSX.Element => {
  return (
    <FormControl fullWidth error={Boolean(error)} sx={sx}>
      {label ? (
        <Box
          component="label"
          id={htmlFor ? fieldLabelId(htmlFor) : undefined}
          htmlFor={htmlFor}
          sx={{ mb: 0.75 }}
        >
          <Text as="span" variant="label" tone="muted">
            {label}
          </Text>
        </Box>
      ) : null}
      {children}
      <FormHelperText
        sx={{
          minHeight: 16,
          mt: 0.5,
          mb: 0,
          mx: 0,
          lineHeight: '16px',
          visibility: error ? 'visible' : 'hidden',
        }}
      >
        {error || '\u00a0'}
      </FormHelperText>
    </FormControl>
  );
};
